<template>
	<el-dialog class="createSonTaskDialog" top="0px" append-to-body width="1000px" title="交接任务" :visible.sync="dialogVisible" @close="cancelDialog">
		<!--<commonSelect @getValue="toGetValue" @setValue="toSetValue" @verifyMethod="verifyMethod" setWidth='250px' :myData='obj' :myOption='opt'></commonSelect>-->
		<el-form :model="createTaskMeg" :rules="rules" width="980px" class="createTaskForm" label-position="left">
			<el-row>
				<el-col :span="24">
					<el-form-item label="任务名称" label-width="100px">
						<el-input
							readonly
						  	v-model="createTaskMeg.taskName">
						</el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="任务类型" label-width="100px" prop="taskType" >
						<!--<el-input>交接任务</el-input>-->
						<el-select style="width: 360px;" disabled  v-model="createTaskMeg.taskType" placeholder="请选择类型">
							<el-option v-for="item in taskTypeList " :key="item.ID " :label="item.NAME " :value="item.ID"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="指派给" label-width="100px">
						<selectExcuteHuman ref="excuteHuman" :inputDisable="excuteHumanDisable" @getValue="excuteGetValue" setWidth="100%"></selectExcuteHuman>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="20">
					<el-form-item label="联系人" label-width="100px">
						<selectLinkman ref="linkman" setWidth='100%' :isValidateMethod=false userNameString="report" :isRadio='true' @getValue="linkmanGetValue"></selectLinkman>
					</el-form-item>
				</el-col>
				<el-col :span="4" style="text-align: right;">
					<el-checkbox v-model="createTaskMeg.isEvaluter" label="1" border>评价人</el-checkbox>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="任务等级" label-width="100px">
						<el-select style="width: 360px;" v-model="createTaskMeg.taskLevelSel"  placeholder="请选择 ">
							<el-option v-for="item in taskLevel " :key="item.value " :label="item.label " :value="item.value "> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="任务组" label-width="100px">
						<selectTaskGroup ref="taskGroup" myWidth="100%" @GetTaskGroup="GetTaskGroup"></selectTaskGroup>
						<!-- 接口GetAllTaskGroup -->
						<!-- <el-select v-model="createTaskMeg.taskLevelSel " id="taskLevelSel " name="taskLevelSel " placeholder="请选择 ">
							<el-option v-for="item in taskLevel " :key="item.value " :label="item.label " :value="item.value "> </el-option>
						</el-select> -->
					</el-form-item>
				</el-col>
			</el-row>
			
			<el-row>
				<el-col :span="24">
					<el-form-item label="内容描述" label-width="100px">
						<wangeditor ref="editorTxtSonTask" v-model="createTaskMeg.content"></wangeditor>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="6">
					<el-form-item label="截图" label-width="100px">
						<el-button @click="captureStart" type="primary">截图</el-button>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="截图设置" label-width="100px">
						<el-checkbox v-model="createTaskMeg.hideWindow">隐藏当前窗口</el-checkbox>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="添加附件" label-width="100px">
						<el-upload  class="upload-demo" action="http://localhost:8080" :limit='5' :on-exceed="exceedUpload" :auto-upload="true" ref="upload" :before-upload="beforeUpload " :on-change='handleChange' :file-list="FileList">
							<el-button type="primary">添加附件</el-button>
						</el-upload>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row v-if="createTaskMeg.resolved">
				<el-col :span="24">
					<el-form-item label="解决方案" label-width="100px">
						<el-input type="textarea"
							:autosize="{ minRows: 3}"
							placeholder="请输入解决方案"
							v-model="createTaskMeg.solution">
						</el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<div v-show="moreShow">
				<el-row>
					<el-col :span="8">
						<el-form-item label="报告人" label-width="100px">
							<selectExcuteHuman ref="Proposer" @getValue="selectProposer" ExcuteHumanTitle="选择报告人" setWidth="180px"></selectExcuteHuman>
						</el-form-item>
					</el-col>
					<el-col :span="16">
						<el-form-item label="预约时间" label-width="100px">
							<el-date-picker style="width: 100%;" v-model="createTaskMeg.repairTime" :picker-options="pickerOptions" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
			</div>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-row>
				<el-col :span="8" style="text-align: left;">
					<el-button @click="moreShow = !moreShow">查看更多</el-button>
				</el-col>
				<el-col :span="16">
					<el-button @click="dialogVisible=false">取 消</el-button>
					<el-button @click="reportStart" type="primary">上 报</el-button>
				</el-col>
			</el-row>
		</div>
	</el-dialog>
</template>

<script>
	import commonSelect from '@/components/basicData/commonSelectComponent.vue'
	import { mapState } from 'vuex';
	import cap from '@/capturn/capturnwrapper.js'
	import { getToken } from "../../../util/auth";
	import selectFuncRoom from '@/components/basicData/selectFuncRoom.vue'
	import selectCompanyDept from '@/components/basicData/selectCompanyDeptComponent.vue'
	import selectLinkman from '@/components/basicData/selectLinkmanComponent.vue'
	import selectExcuteHuman from '@/components/basicData/selectExcuteHuman.vue'
	import selectTaskGroup from '@/components/basicData/selectTaskGroup.vue'
	import wangeditor from '@/components/common/editor.vue'
	import selectFacilityComponent from '@/components/basicData/selectFacilityComponent.vue'
	import { GetTaskTypeList, AddEvent, GetSysUserByCode } from "@/api/modules/basicData/task";
	import { GetAllContactTaskStakeholder } from '@/api/modules/basicData/personnel'
	
	const cookieUser = getToken();
	export default {
		name: "CreateTask",
		props: {
			nameTask: {
				type: String,
				default: ''
			},
			listFile: {},
			contact:{}
		},
		components: {
			selectFuncRoom,
			selectLinkman,
			selectExcuteHuman,
			selectCompanyDept,
			wangeditor,
			selectTaskGroup,
			selectFacilityComponent,
			commonSelect
		},
		data() {
			return {
				obj: {
					idArray: [],
					imageType: [{
						type: -2,
						imgPath: require('@/assets/img/机构.png')
					},{
						type: -1,
						imgPath: require('@/assets/img/组织.png')
					},{
						type: 0,
						imgPath: require('@/assets/img/未知状态.png')
					},{
						type: 1,
						imgPath: require('@/assets/img/人员.png')
					}, {
						type: 2,
						imgPath: require('@/assets/img/人员 (女).png')
					}, {
						type: 3,
						imgPath: require('@/assets/img/计算机.png')
					}, {
						type: 4,
						imgPath: require('@/assets/img/分类.png')
					}],
					checkField: {
						Id: 'ID', //区别上下级
						Pid: 'ParentID',
						Key: 'ID', //数据标识，相同key则为同一条数据（例如不同组织下同一人）
						Type: 'ContactType', //类型区别字段如Type
						TypeValue: [0,1,2,3], //有效的type值
						ValidField: ['Name'],
						ShowField: 'Name'
					}
				},
				opt: {
					commomShowPlaceholder: '', //输入框默认提示
					commonDialogTitle: '测试控件', //弹出窗标题
					commonCheckedDescription: '测试已选', //右侧table标题
					isRadio: false //单双选
				},
				
				
				dialogVisible: false,
				deptIdArray: [],
				moreShow: false, // 显示更多
				createTaskMeg: {
					taskName: '', //任务名称
					isEvaluter: true, // 是否是评价人
					resolved: false, // 是否已解决
					content: "", //内容描述
					funcRoom: null, //功能间信息
					man: '',
					proposer: null, // 报告人
					taskLevelSel: '1',
					focusLevelSel: '',
					createIdentitySel: '',
					repairTime:[new Date(), (new Date().setTime(new Date().getTime() + 3600 * 1000 * 2)) ],
					hideWindow: true, // 是否隐藏当前窗口
					taskType: null,
					solution: "",
					linkUser: {}, //联系人
					ReceiveUser: {}, // 仅验证使用
					excuterUser: {}, // 接收人
					reportDept: null, // 选择的组织。
					taskGroup: null,
					mech:{ // 机构信息
						ID: this.companyId,
						NAME: this.companyName
					},
				},
				rules: {
					taskType: [{ required: true }],
				},
				taskTypeList: [],
				receiveUserIdArray: [], // 接收方默认的ID
				FileList: [],
				pickerOptions:{
					shortcuts: [{
					text: '两小时内',
					onClick(picker) {
					  const end = new Date();
					  const start = new Date();
					  end.setTime(start.getTime() + 3600 * 1000 * 2);
					  picker.$emit('pick', [start, end]);
					}
				  }, {
					text: '一天内',
					onClick(picker) {
					  const end = new Date();
					  const start = new Date();
					  end.setTime(start.getTime() + 3600 * 1000 * 24);
					  picker.$emit('pick', [start, end]);
					}
				  }, {
					text: '三天内',
					onClick(picker) {
					  const end = new Date();
					  const start = new Date();
					  end.setTime(start.getTime() + 3600 * 1000 * 24 * 3);
					  picker.$emit('pick', [start, end]);
					}
				  }]
				},
				excuteHumanDisable: false,
				taskLevel: [
					{
						value: '0',
						label: '重要且紧急'
					}, {
						value: '1',
						label: '重要不紧急'
					}, {
						value: '2',
						label: '紧急不重要'
					}, {
						value: '3',
						label: '不重要不紧急'
					},
				],
				focusLevel:[
					{
						value: '0',
						label: '不关注'
					}, {
						value: '1',
						label: '一级关注'
					}, {
						value: '2',
						label: '二级关注'
					}, {
						value: '3',
						label: '三级关注'
					},
				],
			}
		},
		computed: {
			...mapState({
				userId:state => state.task.userId,
				ServerCenterIds: state => state.task.ServerCenterIds,
				createIdentity: state => state.task.createIdentity,
				account: state => state.task.account,
				contactId: state => state.task.contactId,
				realName: state => state.task.realName,
				departmentId: state => state.user.departmentId,
				departmentName: state => state.user.departmentName,
				companyId: state => state.user.companyId,
				companyName: state => state.user.companyName,
			}),
			
		},
		mounted() {
			if(!this.ServerCenterIds){
				this.$store.dispatch("changeServerCenterIds");
			}
			if(!this.createIdentity.length){
				this.$store.dispatch("GetServerCenterByUserId")
			}
			if(!this.contactId){
				GetSysUserByCode(this.account).then((res)=>{
					this.$store.state.task.contactId = res.CONTACTID;
				})
			}
		},
		created(){
			cap.Init(this); //初始化截图插件。
		},
		watch: {
			dialogVisible(val){
				if(val){
					this.initCreatTaskInfo()
				}
			}
		},
		methods: {
			toGetValue(value, callback) {//为控件绑定值
				console.log("验证通过")
				console.log("获取的值为")
				console.log(value)
				callback(true)
			},
			toSetValue(value, callback) {
				GetAllContactTaskStakeholder("","","1").then(response => {
					console.log(response,"干系人")
					callback(response)
				})
			},
			verifyMethod(value, callback) {
				var res = {
					status: true,
					message: ''
				}
				if(value.Name.indexOf("孙") != -1) {
					res.status = false
					res.message = "不能姓孙"
				}
				callback(res)
			},
			
			getTaskName(){
				this.FileList.push(this.listFile);
				this.createTaskMeg = Object.assign({}, this.createTaskMeg, { taskName: this.nameTask} );
			},
			
			initCreatTaskInfo(){ // 初始化创建任务的信息
				this.createTaskMeg.repairTime = [];
				this.createTaskMeg.repairTime.push(new Date());
				this.createTaskMeg.repairTime.push((new Date().setTime(new Date().getTime() + 3600 * 1000 * 2)));
				this.createTaskMeg.taskLevelSel = "1";
				this.createTaskMeg.focusLevelSel = "0";
				this.createTaskMeg.taskName = "";
				this.createTaskMeg.createIdentitySel = "0";
				this.createTaskMeg.resolved = false;
				this.createTaskMeg.content = "";
				this.createTaskMeg.hideWindow = true;
				this.FileList = [];
				this.initTaskType();
				setTimeout(()=>{
					this.$refs.linkman.initDefaultLink(this.contactId)
					this.$refs.taskGroup.reset();
					this.$refs.Proposer.reset();
					this.$refs.excuteHuman.reset();
				},500)
			},
			initTaskType(){ // 初始化任务类型
				GetTaskTypeList().then((res)=>{
					if(res.length > 0){
						this.taskTypeList = res;
						var defaultType = res.filter((a)=>{
							return (a.ID == "3ee9c55fe2b44efe")
						})
						if(defaultType.length > 0){
							this.createTaskMeg.taskType = defaultType[0].ID
						}else{
							this.createTaskMeg.taskType = res[0].ID
						}
					}
				})
			},
			GetTaskGroup(data){
				if(data){
					this.createTaskMeg.taskGroup = data;
				}else{
					this.createTaskMeg.taskGroup = null;
				}
			},
			toGetFuncRoomValue(data){ // 选择完了功能间。
				if(data.length > 0){
					console.log("选择了功能间:"+ data[0].NAME)
					this.createTaskMeg.funcRoom = data[0];
					this.createTaskMeg.mech = {
						ID: data[0].CompanyExId,
						NAME:data[0].CompanyExName
					};
					this.deptIdArray.push(data[0].DeptId)// 赋值到组织
				}else{
					this.createTaskMeg.funcRoom = null;
				}
			},
			linkmanGetValue(value){// 选择的联系人
				console.log("联系人返回的信息:",value)
				this.createTaskMeg.linkUser = value;
			},
			excuteGetValue(value) { // 选择了接收人
				if (value) {
					this.createTaskMeg = Object.assign({}, this.createTaskMeg, {
						excuterUser: value
					});
				} else {
					this.createTaskMeg = Object.assign({}, this.createTaskMeg, {
						excuterUser: {}
					});
				}
			},
			selectProposer(value){ // 报告人
				if(value){
					this.createTaskMeg.proposer = value;
				}else{
					this.createTaskMeg.proposer = null;
				}
			},
			
			ShowDownLoad(content){ // 未安装插件提示下载
				this.$message({
					type: 'warning',
					dangerouslyUseHTMLString: true,
					message: content,
					showClose: true,
					duration: 0
				});
			},
			captureStart(){ // 截图开始
				cap.StartCapture(this.createTaskMeg.hideWindow,this);
			},
			beforeUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 10
				if(!isLt2M) {
					this.$message.warning('上传单个文件大小不能超过 10MB!')
					return
				}
				this.FileList.push(file)
				return false 
			},
			exceedUpload(file, fileList){
				this.$message.warning('最多上传五个文件')
			},
			handleChange(file, fileList) {
				console.log(this.FileList)
			},
			setAppendContent(imgHtml){
				this.$refs.editorTxtSonTask.setAppendContent(imgHtml);
			},
			facilityGetValue(value) { // 选择设备
				console.log(value)
			},
			HaveVal(val){
				return (val ? val : "")
			},
			Guid(){
				return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
					var r = Math.random() * 16 | 0,
						v = c == 'x' ? r : (r & 0x3 | 0x8);
					return v.toString(16);
				});
			},
			TimeFormat(time){
				var newTime =  new Date(time);
				function HaveZero(t){
					return (t < 10 ? ("0" + t) : t);
				}
				var year = newTime.getFullYear();
				var month = HaveZero(newTime.getMonth() + 1);
				var day = HaveZero(newTime.getDate());
				var hours = HaveZero(newTime.getHours());
				var min = HaveZero(newTime.getMinutes());
				var sec = HaveZero(newTime.getSeconds());
				return (`${year}-${month}-${day}T${hours}:${min}:${sec}`)
			},
			
			reportStart(){ // 开始上报准备
				var reportData = {}; //上报的数据用这个
				var guid = this.Guid();
				reportData.ID = guid.replace(/-/g,"").substring(0,16);// 任务ID
				reportData.CREATESOURCE = 3; // 创建来源
				reportData.CREATEUSERID = reportData.PROPOSERID = this.userId;
				reportData.CREATEUSERNAME  = reportData.PROPOSERNAME = this.realName;
				reportData.CREATEDEPTID = reportData.PROPOSERDEPTID = this.departmentId;
				reportData.CREATEDEPTNAME = reportData.PROPOSERDEPTNAME = this.departmentName;
				reportData.CREATECOMPANYID = this.companyId ? this.companyId : "";
				reportData.CREATECOMPANYNAME = this.companyName ? this.companyName : "";
				reportData.CUSTOMERID = this.createTaskMeg.mech.ID; // 客户机构ID
				reportData.CUSTOMERNAME = this.createTaskMeg.mech.NAME;// 客户机构名称
				//////////////页面数据依次排列
				if(this.createTaskMeg.funcRoom && this.createTaskMeg.funcRoom.ID) {//   功能间ID
					reportData.FUNCROOMID = this.createTaskMeg.funcRoom.ID;
				}else{
					reportData.FUNCROOMID = "";
				}
				var linkUser = this.createTaskMeg.linkUser;
				if(linkUser.ID) { //如果是选的联系人。
					reportData.LINKMAN = linkUser.ID; //联系人ID
					if(linkUser.PHONE && linkUser.NAME.indexOf(linkUser.PHONE) != -1) { //如果联系人名字里包含了手机号就把手机号设为空
						linkUser.NAME = linkUser.NAME.replace(linkUser.PHONE, "")
					} else { //联系人号码
						reportData.LINKPHONE = this.HaveVal(linkUser.PHONE);
					};//联系人名称要特殊处理。
					reportData.LINKMANNAME = linkUser.NAME + ',' + this.HaveVal(linkUser.PHONE) + ',' + this.HaveVal(linkUser.POST) + ',' + (linkUser.GRADE ? (linkUser.GRADE + '(重要级别)') : '');
				}else{
					reportData.LINKMAN=""; //手动输入的则自己为准。
					reportData.LINKPHONE="";
					reportData.LINKMANNAME = linkUser;
				};
				reportData.TASKDEGREE = this.createTaskMeg.taskLevelSel // 任务重要度
				if(this.createTaskMeg.taskGroup){ // 任务组
					reportData.TaskGroupName = this.createTaskMeg.taskGroup.Name;
					reportData.TaskGroupId = this.createTaskMeg.taskGroup.Value;
				}
				reportData.EVENTNAME = this.createTaskMeg.taskName; // 标题
				var ident = this.createTaskMeg.createIdentitySel;
				var excuterUser = this.createTaskMeg.excuterUser;
				var selectedExcuteUser = null;
				
				reportData.SERVERCENTERID = this.contact.value;
				reportData.SERVERCENTERNAME = this.contact.label;
				if (excuterUser && excuterUser.ID) {
					selectedExcuteUser = excuterUser;
				}
				if(selectedExcuteUser){ // 接收人赋值。
					reportData.EXCUTEDEPTID = selectedExcuteUser.DEPTID;
					reportData.EXCUTEDEPTNAME = selectedExcuteUser.DEPTNAME;
					reportData.EXCUTEUSERID = selectedExcuteUser.ID;
					reportData.EXCUTEUSERNAME = selectedExcuteUser.NAME;
					reportData.EXCUTEUSERPHONE = (selectedExcuteUser.TELEPHONE ? selectedExcuteUser.TELEPHONE : '')
				}else{
					reportData.EXCUTEDEPTID = reportData.EXCUTEDEPTNAME = reportData.EXCUTEUSERID = reportData.EXCUTEUSERNAME = reportData.EXCUTEUSERPHONE = "";
				}
				///////////接收方接收
				if (this.createTaskMeg.taskType) { // 任务类型
					var selectType = this.taskTypeList.filter((a) => {
						return (a.ID == this.createTaskMeg.taskType)
					})
					var taskType = selectType[0];
					reportData.EVENTTYPE = taskType.ID;
					reportData.EVENTCLASS = taskType.ID;
					reportData.EVENTTYPENAME = taskType.NAME;
				}
				if(this.createTaskMeg.resolved){ // 如果点了已解决  ->  赋值解决方案。
					reportData.EXCUTEUSERREPLY = this.createTaskMeg.solution;
				}
				reportData.CONTENT = this.createTaskMeg.content; // 报修内容
				var proposer = this.createTaskMeg.proposer;
				if(proposer){
					reportData.PROPOSERID =  proposer.ID;
					reportData.PROPOSERNAME = proposer.NAME;
					reportData.PROPOSERDEPTID = proposer.DEPTID;
					reportData.PROPOSERDEPTNAME = proposer.DEPTNAME;
				}
				reportData.STATE = 0;
				reportData.EFFECTDEGREE = 0;
				reportData.EMERGENCEDREGEE = 0;
				reportData.CREATETIME= '2018-12-22T10:52:45';
				reportData.REPAIRTIME1 = this.TimeFormat(this.createTaskMeg.repairTime[0])
				reportData.REPAIRTIME2 = this.TimeFormat(this.createTaskMeg.repairTime[1])
				
				reportData.EVENTDEVICES = [];
				var formData = new FormData()
				if(this.FileList.length > 0) {
					for(var i = 0; i < this.FileList.length; i++) {
						formData.append(i.toString(), this.FileList[i]);
					}
				}
				formData.append('SolveMySelf', this.createTaskMeg.resolved);
				formData.append('EventInfo', JSON.stringify(reportData));
				AddEvent(formData).then((res)=>{
					this.$message({
						message: '报修成功!',
						type: 'success'
					});
					this.initCreatTaskInfo();
					this.$store.dispatch('changeTaskSource');
					this.dialogVisible = false;
					this.$emit("subSon",{name:"关闭"});
				}).catch((err)=>{
					this.$message.error("报修失败"+err);
					console.error(err)
				})
			},
			cancelDialog() {
				this.initCreatTaskInfo();
			},
		},
	}
</script>

<style scoped lang="less">
	.createSonTaskDialog{
		height: 100%;
		/*overflow: hidden;*/
		.el-form {
			text-align: left;
		}
		.createSonTaskDialog .el-form-item {
		    margin-bottom: 10px;
		}
	}
	.createTaskForm{
 		/*height: 500px;
 		overflow-y: auto;
 		overflow-x: hidden;*/
	}
	.selectInput {
		display: inline-block;
	}
	
</style>